import React from "react";
import { Container } from "reactstrap";

const Footer = () => {
  return (
    <Container
      fluid
      tag="footer"
      className="text-center footer text-uppercase fixed-bottom p-3 d-none d-sm-block"
    >
      Github search app with firebase
    </Container>
  );
};

export default Footer;
